"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SROnly = exports.TextEllipsis = exports.TextEllipsisCSS = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TextEllipsisCSS = (0, _styledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
exports.TextEllipsisCSS = TextEllipsisCSS;

var TextEllipsis = _styledComponents["default"].span.withConfig({
  displayName: "Text__TextEllipsis",
  componentId: "u38q2t-0"
})(["", ""], TextEllipsisCSS);
/* Visually hidden but readable by screen readers */


exports.TextEllipsis = TextEllipsis;

var SROnly = _styledComponents["default"].span.withConfig({
  displayName: "Text__SROnly",
  componentId: "u38q2t-1"
})(["clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;top:0;left:0;white-space:nowrap;width:1px;"]);

exports.SROnly = SROnly;